export type MuleSoftBodyShopRecord = {
  NoKVPS: string;
  NoCompte: string;
  DateDebut: string;
  DateFin: string | null;
  RaisonSociale: string;
  Siret: string;
  NumeroVoie: string | null;
  TypeVoie: string | null;
  NomVoie: string | null;
  CodePostal: string | null;
  NomVille: string | null;
  DateFermeture: string | null;
  TypeCompteLibelle: string;
  ProtocoleLibelle: string | null;
};

export type MuleSoftBodyShopsApiResponse = {
  records: MuleSoftBodyShopRecord[];
};

export const MULESOFT_BODY_SHOPS_MOCK_RESPONSE: MuleSoftBodyShopsApiResponse = {
  records: [
    {
      NoKVPS: "FRAA54600",
      NoCompte: "07004600",
      DateDebut: "1988-02-15",
      DateFin: null,
      RaisonSociale: "BESSE ET AUPY",
      Siret: "32256489900035",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "24600",
      NomVille: "RIBERAC",
      DateFermeture: null,
      TypeCompteLibelle: "CARAU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAA54602",
      NoCompte: "07004602",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "BRUNO SCHERER ENTREPRISE",
      Siret: "39149815100029",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "64700",
      NomVille: "HENDAYE",
      DateFermeture: null,
      TypeCompteLibelle: "CARAU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAA54606",
      NoCompte: "07004606",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "CARROSSERIE MOLETTA-OBRADO",
      Siret: "30600338500011",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "82000",
      NomVille: "MONTAUBAN",
      DateFermeture: null,
      TypeCompteLibelle: "CARAU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAA54609",
      NoCompte: "07004609",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "C E V",
      Siret: "58214221200049",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "78920",
      NomVille: "ECQUEVILLY",
      DateFermeture: null,
      TypeCompteLibelle: "CARAU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAA54616",
      NoCompte: "07004616",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "DUCARME",
      Siret: "38333873800024",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "42350",
      NomVille: "LA TALAUDIERE",
      DateFermeture: null,
      TypeCompteLibelle: "CARAU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAA54617",
      NoCompte: "07004617",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "DIRECT MEDICAL",
      Siret: "35246906800030",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "64700",
      NomVille: "HENDAYE",
      DateFermeture: null,
      TypeCompteLibelle: "CARAU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAA54619",
      NoCompte: "07004619",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "FIAULT",
      Siret: "42347192900012",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "53110",
      NomVille: "LASSAY LES CHATEAUX",
      DateFermeture: null,
      TypeCompteLibelle: "CARAU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAA54624",
      NoCompte: "07004624",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "GRUAU LAVAL",
      Siret: "41027519200012",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "53940",
      NomVille: "ST BERTHEVIN",
      DateFermeture: null,
      TypeCompteLibelle: "CARAU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAA54628",
      NoCompte: "07004628",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "GRUAU VENDEE",
      Siret: "38146133400058",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "85290",
      NomVille: "ST LAURENT SUR SEVRE",
      DateFermeture: null,
      TypeCompteLibelle: "CARAU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAA54634",
      NoCompte: "07004634",
      DateDebut: "1988-02-17",
      DateFin: null,
      RaisonSociale: "LABBE",
      Siret: "31256478400048",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "22403",
      NomVille: "LAMBALLE",
      DateFermeture: null,
      TypeCompteLibelle: "CARAU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAS54729",
      NoCompte: "07004729",
      DateDebut: "2015-08-12",
      DateFin: null,
      RaisonSociale: "AUTO PLUS SYSTEM",
      Siret: "41038646000019",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "51000",
      NomVille: "CHALONS EN CHAMPAGNE",
      DateFermeture: null,
      TypeCompteLibelle: "CARSE",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAS54802",
      NoCompte: "07004802",
      DateDebut: "2017-10-20",
      DateFin: null,
      RaisonSociale: "SD SERVICES",
      Siret: "80313226500023",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "57070",
      NomVille: null,
      DateFermeture: null,
      TypeCompteLibelle: "CARSE",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAS54893",
      NoCompte: "07004893",
      DateDebut: "2021-06-03",
      DateFin: null,
      RaisonSociale: "WURTH FRANCE",
      Siret: "66850296600025",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "67150",
      NomVille: "ERSTEIN",
      DateFermeture: null,
      TypeCompteLibelle: "CARSE",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAS58039",
      NoCompte: "07008039",
      DateDebut: "2011-12-09",
      DateFin: null,
      RaisonSociale: "SOJADIS",
      Siret: "33964780200018",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "49510",
      NomVille: "JALLAIS",
      DateFermeture: null,
      TypeCompteLibelle: "CARSE",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAS58060",
      NoCompte: "07008060",
      DateDebut: "2014-09-25",
      DateFin: null,
      RaisonSociale: "DRIVE MATIC LEGRAND",
      Siret: "38360852800014",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "92310",
      NomVille: "SEVRES",
      DateFermeture: null,
      TypeCompteLibelle: "CARSE",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAS55004",
      NoCompte: "07005004",
      DateDebut: "2026-05-11",
      DateFin: null,
      RaisonSociale: " GARAGE FABIEN PONS",
      Siret: "32603527600012",
      NumeroVoie: "12",
      TypeVoie: "RUE",
      NomVoie: "FRANCOIS MAYNARD",
      CodePostal: "15000",
      NomVille: "AURILLAC",
      DateFermeture: null,
      TypeCompteLibelle: "CARSE",
      ProtocoleLibelle: "CAR",
    },
    {
      NoKVPS: "FRAC54600",
      NoCompte: "07004600",
      DateDebut: "1988-02-15",
      DateFin: null,
      RaisonSociale: "BESSE ET AUPY",
      Siret: "32256489900035",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "24600",
      NomVille: "RIBERAC",
      DateFermeture: null,
      TypeCompteLibelle: "CARSK",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAC54602",
      NoCompte: "07004602",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "BRUNO SCHERER ENTREPRISE",
      Siret: "39149815100029",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "64700",
      NomVille: "HENDAYE",
      DateFermeture: null,
      TypeCompteLibelle: "CARSK",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAC54606",
      NoCompte: "07004606",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "CARROSSERIE MOLETTA-OBRADO",
      Siret: "30600338500011",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "82000",
      NomVille: "MONTAUBAN",
      DateFermeture: null,
      TypeCompteLibelle: "CARSK",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAC54609",
      NoCompte: "07004609",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "C E V",
      Siret: "58214221200049",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "78920",
      NomVille: "ECQUEVILLY",
      DateFermeture: null,
      TypeCompteLibelle: "CARSK",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAC54616",
      NoCompte: "07004616",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "DUCARME",
      Siret: "38333873800024",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "42350",
      NomVille: "LA TALAUDIERE",
      DateFermeture: null,
      TypeCompteLibelle: "CARSK",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAC54617",
      NoCompte: "07004617",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "DIRECT MEDICAL",
      Siret: "35246906800030",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "64700",
      NomVille: "HENDAYE",
      DateFermeture: null,
      TypeCompteLibelle: "CARSK",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAC54619",
      NoCompte: "07004619",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "FIAULT",
      Siret: "42347192900012",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "53110",
      NomVille: "LASSAY LES CHATEAUX",
      DateFermeture: null,
      TypeCompteLibelle: "CARSK",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAC54624",
      NoCompte: "07004624",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "GRUAU LAVAL",
      Siret: "41027519200012",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "53940",
      NomVille: "ST BERTHEVIN",
      DateFermeture: null,
      TypeCompteLibelle: "CARSK",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAC54628",
      NoCompte: "07004628",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "GRUAU VENDEE",
      Siret: "38146133400058",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "85290",
      NomVille: "ST LAURENT SUR SEVRE",
      DateFermeture: null,
      TypeCompteLibelle: "CARSK",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAC54634",
      NoCompte: "07004634",
      DateDebut: "1988-02-17",
      DateFin: null,
      RaisonSociale: "LABBE",
      Siret: "31256478400048",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "22403",
      NomVille: "LAMBALLE",
      DateFermeture: null,
      TypeCompteLibelle: "CARSK",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAN54600",
      NoCompte: "07004600",
      DateDebut: "1988-02-15",
      DateFin: null,
      RaisonSociale: "BESSE ET AUPY",
      Siret: "32256489900035",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "24600",
      NomVille: "RIBERAC",
      DateFermeture: null,
      TypeCompteLibelle: "CARVU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAN54602",
      NoCompte: "07004602",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "BRUNO SCHERER ENTREPRISE",
      Siret: "39149815100029",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "64700",
      NomVille: "HENDAYE",
      DateFermeture: null,
      TypeCompteLibelle: "CARVU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAN54606",
      NoCompte: "07004606",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "CARROSSERIE MOLETTA-OBRADO",
      Siret: "30600338500011",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "82000",
      NomVille: "MONTAUBAN",
      DateFermeture: null,
      TypeCompteLibelle: "CARVU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAN54609",
      NoCompte: "07004609",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "C E V",
      Siret: "58214221200049",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "78920",
      NomVille: "ECQUEVILLY",
      DateFermeture: null,
      TypeCompteLibelle: "CARVU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAN54616",
      NoCompte: "07004616",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "DUCARME",
      Siret: "38333873800024",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "42350",
      NomVille: "LA TALAUDIERE",
      DateFermeture: null,
      TypeCompteLibelle: "CARVU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAN54617",
      NoCompte: "07004617",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "DIRECT MEDICAL",
      Siret: "35246906800030",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "64700",
      NomVille: "HENDAYE",
      DateFermeture: null,
      TypeCompteLibelle: "CARVU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAN54619",
      NoCompte: "07004619",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "FIAULT",
      Siret: "42347192900012",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "53110",
      NomVille: "LASSAY LES CHATEAUX",
      DateFermeture: null,
      TypeCompteLibelle: "CARVU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAN54624",
      NoCompte: "07004624",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "GRUAU LAVAL",
      Siret: "41027519200012",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "53940",
      NomVille: "ST BERTHEVIN",
      DateFermeture: null,
      TypeCompteLibelle: "CARVU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAN54628",
      NoCompte: "07004628",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "GRUAU VENDEE",
      Siret: "38146133400058",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "85290",
      NomVille: "ST LAURENT SUR SEVRE",
      DateFermeture: null,
      TypeCompteLibelle: "CARVU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAN54634",
      NoCompte: "07004634",
      DateDebut: "1988-02-17",
      DateFin: null,
      RaisonSociale: "LABBE",
      Siret: "31256478400048",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "22403",
      NomVille: "LAMBALLE",
      DateFermeture: null,
      TypeCompteLibelle: "CARVU",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAV54600",
      NoCompte: "07004600",
      DateDebut: "1988-02-15",
      DateFin: null,
      RaisonSociale: "BESSE ET AUPY",
      Siret: "32256489900035",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "24600",
      NomVille: "RIBERAC",
      DateFermeture: null,
      TypeCompteLibelle: "CARVW",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAV54602",
      NoCompte: "07004602",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "BRUNO SCHERER ENTREPRISE",
      Siret: "39149815100029",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "64700",
      NomVille: "HENDAYE",
      DateFermeture: null,
      TypeCompteLibelle: "CARVW",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAV54606",
      NoCompte: "07004606",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "CARROSSERIE MOLETTA-OBRADO",
      Siret: "30600338500011",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "82000",
      NomVille: "MONTAUBAN",
      DateFermeture: null,
      TypeCompteLibelle: "CARVW",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAV54609",
      NoCompte: "07004609",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "C E V",
      Siret: "58214221200049",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "78920",
      NomVille: "ECQUEVILLY",
      DateFermeture: null,
      TypeCompteLibelle: "CARVW",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAV54616",
      NoCompte: "07004616",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "DUCARME",
      Siret: "38333873800024",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "42350",
      NomVille: "LA TALAUDIERE",
      DateFermeture: null,
      TypeCompteLibelle: "CARVW",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAV54617",
      NoCompte: "07004617",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "DIRECT MEDICAL",
      Siret: "35246906800030",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "64700",
      NomVille: "HENDAYE",
      DateFermeture: null,
      TypeCompteLibelle: "CARVW",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAV54619",
      NoCompte: "07004619",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "FIAULT",
      Siret: "42347192900012",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "53110",
      NomVille: "LASSAY LES CHATEAUX",
      DateFermeture: null,
      TypeCompteLibelle: "CARVW",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAV54624",
      NoCompte: "07004624",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "GRUAU LAVAL",
      Siret: "41027519200012",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "53940",
      NomVille: "ST BERTHEVIN",
      DateFermeture: null,
      TypeCompteLibelle: "CARVW",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAV54628",
      NoCompte: "07004628",
      DateDebut: "1988-02-16",
      DateFin: null,
      RaisonSociale: "GRUAU VENDEE",
      Siret: "38146133400058",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "85290",
      NomVille: "ST LAURENT SUR SEVRE",
      DateFermeture: null,
      TypeCompteLibelle: "CARVW",
      ProtocoleLibelle: null,
    },
    {
      NoKVPS: "FRAV54634",
      NoCompte: "07004634",
      DateDebut: "1988-02-17",
      DateFin: null,
      RaisonSociale: "LABBE",
      Siret: "31256478400048",
      NumeroVoie: null,
      TypeVoie: null,
      NomVoie: null,
      CodePostal: "22403",
      NomVille: "LAMBALLE",
      DateFermeture: null,
      TypeCompteLibelle: "CARVW",
      ProtocoleLibelle: null,
    },
  ],
};
